import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TarifaService {
  private ENDPOINT = environment.ENDPOINTS.TARIFA;

  constructor(
    private http: HttpClient
  ) { }

  saveTarifa(data: any) {
    return this.http.post<any>(`${this.ENDPOINT}`, data);
  }


  getTarifas() {
    return this.http.get<any[]>(`${ this.ENDPOINT }`);
  }
  getTarifasResource() {
    return this.http.get<any[]>(`${ this.ENDPOINT }/get/tarifas`);
  }
  //cat_tarifas
  getCatTarifas() {
    return this.http.get<any[]>(`${ this.ENDPOINT}`);
  }
  getCarriles() {
    return this.http.get<any[]>(this.ENDPOINT+'/get/carriles')
  }

  updateActiveTarifas(tarifa) {
    return this.http.put<any[]>(`${ this.ENDPOINT}/${tarifa.idTarifa}`, tarifa);
  }


}
